import { ShieldCheck } from 'lucide-react';
import React from 'react';

import { MultiSheetImportPage } from '@/features/imports/MultiSheetImportPage';

export const ImportInsurancePage = (): React.JSX.Element => (
  <MultiSheetImportPage
    config={{
      moduleKey: 'insurance',
      titleSingular: 'insurance',
      titlePlural: 'insurance',
      routePrefix: 'insurance',
      listPath: '/insurance',
      ListIcon: ShieldCheck,
      invalidateOnSuccess: ['insurance', 'insurance-pricing-tiers'],
      summaryFieldsBySheet: {
        Insurance: ['insuranceKey', 'name', 'targetCountry'],
        PricingTiers: ['insuranceKey', 'tierName', 'feePerApplicant'],
      },
    }}
  />
);
